/* Generated by scripts/build-picker-icons.mjs. Do not edit directly. */
import type { PickerIconProps } from "../types.ts";

export function SymbolLocalMallIcon({
  size = 24,
  color = "currentColor",
  title,
  ...svgProps
}: PickerIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      data-icon="symbol-local-mall"
      data-variant="filled"
      role={title ? "img" : undefined}
      aria-hidden={title ? undefined : true}
      focusable="false"
      {...svgProps}
    >
      {title ? <title>{title}</title> : null}
      <path d="M4.85 22.8Q3.75 22.8 2.98 22.02Q2.2 21.25 2.2 20.15L2.2 8.35Q2.2 7.25 2.98 6.47Q3.75 5.7 4.85 5.7L6.3 5.7Q6.3 3.33 7.96 1.66Q9.63 0 12 0Q14.38 0 16.04 1.66Q17.7 3.33 17.7 5.7L19.15 5.7Q20.25 5.7 21.02 6.47Q21.8 7.25 21.8 8.35L21.8 20.15Q21.8 21.25 21.02 22.02Q20.25 22.8 19.15 22.8ZM8.95 5.7L15.05 5.7Q15.05 4.42 14.16 3.54Q13.28 2.65 12 2.65Q10.72 2.65 9.84 3.54Q8.95 4.42 8.95 5.7ZM12.03 15.1Q14.2 15.1 15.82 13.76Q17.45 12.43 17.45 10.65Q17.45 10.13 17.07 9.76Q16.7 9.4 16.13 9.4Q15.7 9.4 15.35 9.68Q15 9.95 14.85 10.45Q14.57 11.32 13.78 11.89Q12.97 12.45 12 12.45Q11.03 12.45 10.24 11.89Q9.45 11.32 9.18 10.45Q9 9.93 8.68 9.66Q8.35 9.4 7.9 9.4Q7.33 9.4 6.95 9.76Q6.58 10.13 6.58 10.65Q6.58 12.43 8.21 13.76Q9.85 15.1 12.03 15.1Z" fill={color} />
    </svg>
  );
}
